export const EO_ACCESS_LEVELS = ["Coordinator", "Supervisor", "Administrator"];

export const MARKETPLACE_SELLER_TYPES = [
  "Artisan / Crafted Goods",
  "Beverage - Alcoholic / Bar",
  "Beverage - Craft Alcohol Sales",
  "Clothing",
  "Food - Service",
  "Food Truck",
  "Meats & Produce",
  "Flowers & Plants",
  "Beverage - Non Alcoholic",
  "Children's Goods",
  "Food - Prepared",
  "Health, Wellness & Beauty",
];

export const EO_CREATE_EVENT_FEE_BREAKDOWN_DESCRIPTIONS = [
  {
    label: "Platform Service Fee (15%):",
    description:
      "Pebble charges a 15% service fee on each vendor registration to power our marketplace platform. This fee enables secure payment processing, vendor communication tools, application management, document verification, and 24/7 customer support. Similar to platforms like Eventbrite and Airbnb, this fee helps us maintain and improve the services that connect you with quality vendors.",
  },
  {
    label: "Registration Fee (Optional):",
    description:
      "Set a registration fee that vendors pay to participate in your event. This is entirely optional. If you choose not to charge a registration fee, a flat $10 service fee per vendor applies to cover basic platform costs.",
  },
  {
    label: "Tiered Registration Pricing:",
    description:
      "Offer vendors multiple booth options at different price points (e.g., Standard Booth, Corner Booth, Premium Booth). This feature is available exclusively on the Pro plan.",
  },
  {
    label: "Tree Planting Donation ($2):",
    description:
      "Join our Climate Action Initiative! Enable a $2 tree planting contribution per vendor registration. 100% of donations go directly to verified reforestation partners planting trees in areas affected by deforestation. You can make this optional or require it for all vendors. Together, we can make events more sustainable.",
  },
];

export const EO_RECURRING_EVENT_DROPDOWN_OPTIONS = [
  {
    label: "Weekly",
    description: "The event occurs every week",
    value: "weekly",
  },
  {
    label: "Bi-Weekly",
    description: "The event occurs every 2 weeks",
    value: "bi-weekly",
  },
  {
    label: "Monthly",
    description: "The event occurs each month",
    value: "monthly",
  },
  {
    label: "Bi-Monthly",
    description: "The event occurs every 2 months",
    value: "bi-monthly",
  },
  {
    label: "Quarterly",
    description: "The event happens 4 times a year",
    value: "quarterly",
  },
  {
    label: "Annually",
    description: "The event happens every year",
    value: "annually",
  },
  {
    label: "Custom Schedule",
    description: "Enter customized, specific dates for your event",
    value: "custom",
  },
];

export const EO_TYPE_OF_QUESTION_DROPDOWN_OPTIONS = [
  {
    label: "Multiple Choice",
    description: "For questions with specific options",
    value: "multipleChoice",
    questionTitle: "",
    options: [],
  },
  {
    label: "Short Answer",
    description: "For short, open-ended questions",
    value: "shortAnswer",
    questionTitle: "",
  },
  {
    label: "Long Answer",
    description: "For longer questions which need more information",
    value: "longAnswer",
    questionTitle: "",
  },
];

export const SOCIAL_MEDIA_ICONS = {
  instagram: "logo-instagram",
  facebook: "logo-facebook",
  twitter: "logo-twitter",
  tiktok: "logo-tiktok",
  globe: "globe-outline",
};

export const POPULAR_CITIES = [
  'New York, NY',
  'Los Angeles, CA',
  'Chicago, IL',
  'Houston, TX',
  'Phoenix, AZ',
  'Philadelphia, PA',
  'San Antonio, TX',
  'San Diego, CA',
  'Dallas, TX',
  'San Jose, CA'
];

export const DOCUMENT_SUGGESTIONS = {
  common: [
    "Certificate of Insurance",
    "Certificate of Liability",
    "Business License",
    "Tax ID / EIN Document",
    "Vendor Agreement",
    "W-9 Form",
    "Photo ID",
    "Proof of Address",
  ],
  "Food - Service": [
    "Food Handler's Permit",
    "Health Department Certificate",
    "ServSafe Certification",
    "Food Safety Permit",
    "Commercial Kitchen License",
    "Food Vendor Permit",
    "Health Inspection Report",
  ],
  "Food Truck": [
    "Food Truck Permit",
    "Mobile Food Vendor License",
    "Fire Safety Certificate",
    "Vehicle Registration",
    "Propane Tank Certification",
    "Food Handler's Permit",
    "Health Inspection Report",
  ],
  "Food - Prepared": [
    "Cottage Food License",
    "Food Handler's Permit",
    "Kitchen Inspection Certificate",
    "Food Safety Certification",
    "Product Ingredient List",
  ],
  "Beverage - Alcoholic / Bar": [
    "Liquor License",
    "Alcohol Server Certification",
    "TIPS Certification",
    "State Alcohol Permit",
    "Temporary Event Liquor License",
  ],
  "Beverage - Craft Alcohol Sales": [
    "Brewery/Winery License",
    "Alcohol Distribution Permit",
    "State Alcohol Sales Permit",
    "Federal Alcohol Permit",
  ],
  "Beverage - Non Alcoholic": [
    "Beverage Vendor Permit",
    "Health Certificate",
    "Product Safety Certification",
  ],
  "Meats & Produce": [
    "USDA Certification",
    "Organic Certification",
    "Farm License",
    "Cold Storage Certification",
    "Meat Handler's License",
    "Produce Safety Certification",
  ],
  "Health, Wellness & Beauty": [
    "Cosmetology License",
    "Esthetician License",
    "Product Safety Data Sheet",
    "FDA Registration",
    "Massage Therapy License",
  ],
  "Artisan / Crafted Goods": [
    "Artisan Certificate",
    "Product Liability Insurance",
    "Handmade Product Declaration",
  ],
  "Clothing": [
    "Textile Certification",
    "Product Safety Certificate",
    "Resale License",
  ],
  "Flowers & Plants": [
    "Nursery License",
    "Plant Import Permit",
    "Pesticide Application License",
  ],
  "Children's Goods": [
    "CPSC Compliance Certificate",
    "Product Safety Testing Report",
    "Lead-Free Certification",
    "Small Parts Testing Certificate",
  ],
};

export const BASIC_TIER_DOCUMENT_LIMIT = 5;
